// 获取cookie、
export const getFileTyeIconClass = (data) => {
  data.forEach((item) => {
    if (+item.folder === 1){
      item.icons = 'iconfolders'
    } else if (item.suffix === 'GWH5' || item.suffix === 'gwh5'){
      item.icons = `icon-shui-${item.projectType}`
    } else if (item.suffix === 'GHW5' || item.suffix === 'ghw5'){
      item.icons = `icon-gonglu-${item.projectType}`
    } else if (item.suffix === 'GEC5' || item.suffix === 'gec5'){
      if (+item.projectType === 2300){
        item.icons = 'icon-dian-zhao'
      } else if (+item.projectType === 2400){
        item.icons = 'icon-dian-tou'
      } else if (+item.projectType === 2500){
        item.icons = 'icon-dian-yu'
      } else if (+item.projectType === 1000){
        item.icons = 'icon-dian-gai'
      }
    } else if (+item.projectType === 1000){
      item.icons = 'icon1'
    } else if (+item.projectType === 1100){
      item.icons = 'icon2'
    } else if (+item.projectType === 2000){
      item.icons = 'unknown'
    } else if (+item.projectType === 2100){
      item.icons = 'icon15'
    } else if (+item.projectType === 2200){
      item.icons = 'icon16'
    } else if (+item.projectType === 2300){
      item.icons = 'icon11'
    } else if (+item.projectType === 2400){
      item.icons = 'icon12'
    } else if (+item.projectType === 2500){
      item.icons = 'icon10'
    } else if (+item.projectType === 3300){
      item.icons = 'icon5'
    } else if (+item.projectType === 3400){
      item.icons = 'icon4'
    } else if (+item.projectType === 4000){
      item.icons = 'icon3'
    } else if (item.projectType === 4050){
      item.icons = 'icon6'
    } else if (+item.projectType === 4100){
      item.icons = 'icon14'
    } else if (+item.projectType === 4150){
      item.icons = 'icon13'
    } else if (+item.projectType === 4200){
      item.icons = 'icon8'
    } else if (+item.projectType === 4250){
      item.icons = 'icon9'
    } else if (+item.projectType === 4300){
      item.icons = 'icon7'
    } else if (item.suffix.indexOf('mp4') > -1 || item.suffix.indexOf('MP4') > -1){
      item.icons = 'mp4icon'
    } else if (item.suffix.indexOf('dwg') > -1 || item.suffix.indexOf('dwg') > -1){
      item.icons = 'dwgicon'
    } else {
      item.icons = item.suffix
    }
  })
  return data
}
